<!-- Public Header -->
<header class="public-header">
  <div class="header-content">
    <div class="logo-section">
      <img src="images/generic-logo/logo.webp" alt="AI Optima Logo" class="logo-image">
      <!-- <h1>AI Optima</h1> -->
      <p>AI Search & Marketing Intelligence Platform</p>
    </div>
    <div class="auth-buttons">
      <button mat-button routerLink="/login" class="login-btn">
        <mat-icon>login</mat-icon>
        Login
      </button>
      <button mat-raised-button routerLink="/register" color="primary" class="register-btn">
        <mat-icon>person_add</mat-icon>
        Get Started
      </button>
    </div>
  </div>
</header>

